// Stable anonymous client identity stored in localStorage.
// Used to make comment likes persist across IP changes (e.g. behind Cloudflare,
// mobile network handover, restarted router etc).

const KEY = 'outlaw_client_id';

export function getClientId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    // Private/anonymous mode where localStorage is blocked - fall back to per-tab id
    if (!window.__outlaw_session_id) {
      window.__outlaw_session_id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2);
    }
    return window.__outlaw_session_id;
  }
}

// Mirror the server "I liked this comment" state on-device, so refreshes &
// IP shifts never flicker the heart icon back to empty.
const LIKED_KEY = 'outlaw_liked_comments';

export function getLikedCommentSet() {
  try {
    return new Set(JSON.parse(localStorage.getItem(LIKED_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

export function setCommentLiked(commentId, liked) {
  try {
    const set = getLikedCommentSet();
    if (liked) set.add(commentId);
    else set.delete(commentId);
    localStorage.setItem(LIKED_KEY, JSON.stringify([...set]));
  } catch {
    /* ignore */
  }
}
